/**
 * Avatar utilities and options for user profile customization
 * Using local sports avatar images from assets
 */

// Sports-themed avatars with local image files
export const SPORTS_AVATARS = [
  {
    id: 'sports-1',
    name: 'Player',
    url: require('../assets/profile_avatar/sports_avatar.png'),
    type: 'sports',
    emoji: '⚽'
  },
  {
    id: 'sports-2',
    name: 'Basketball Player',
    url: require('../assets/profile_avatar/basketball_avatar.png'),
    type: 'sports',
    emoji: '🏀'
  },
  {
    id: 'sports-3',
    name: 'Tennis Player',
    url: require('../assets/profile_avatar/tennis_avatar.png'),
    type: 'sports',
    emoji: '🎾'
  },
  {
    id: 'sports-4',
    name: 'Football Player',
    url: require('../assets/profile_avatar/football_avatar.png'),
    type: 'sports',
    emoji: '🏈'
  },
  {
    id: 'sports-6',
    name: 'Ice Hockey Player',
    url: require('../assets/profile_avatar/ice_hockey_avatar.png'),
    type: 'sports',
    emoji: '🏒'
  },
  {
    id: 'sports-7',
    name: 'Cyclist',
    url: require('../assets/profile_avatar/cycling_avatar.png'),
    type: 'sports',
    emoji: '🚴'
  },
  {
    id: 'sports-8',
    name: 'Volleyball Player',
    url: require('../assets/profile_avatar/volleyball_avatar.png'),
    type: 'sports',
    emoji: '🏐'
  },
  {
    id: 'sports-9',
    name: 'Golfer',
    url: require('../assets/profile_avatar/golf_avatar.png'),
    type: 'sports',
    emoji: '⛳'
  },
  {
    id: 'sports-10',
    name: 'Surfer',
    url: require('../assets/profile_avatar/surfing_avatar.png'),
    type: 'sports',
    emoji: '🏄'
  },
  {
    id: 'sports-11',
    name: 'Ice Skater',
    url: require('../assets/profile_avatar/skating_avatar.png'),
    type: 'sports',
    emoji: '⛸️'
  },
];

// Generic avatars removed - sports only
export const GENERIC_AVATARS = [];

// Combined all avatars (sports only)
export const ALL_AVATARS = [...SPORTS_AVATARS];

// Get avatar by ID
export const getAvatarById = (id) => {
  return ALL_AVATARS.find(avatar => avatar.id === id);
};

// Get avatars by type
export const getAvatarsByType = (type) => {
  return ALL_AVATARS.filter(avatar => avatar.type === type);
};
